import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { CustomerOrderTrackingComponent } from './customer-order-tracking/customer-order-tracking.component';
import { EvermileLogoComponent } from './evermile-logo/evermile-logo.component';
import { HttpClientModule } from '@angular/common/http';
import { OrderStatusComponent } from './customer-order-tracking/components/order-status/order-status.component';
import { DisplayDateFormatterPipe } from './pipes/display-date-formatter.pipe';
import { OrderAddressComponent } from './customer-order-tracking/components/order-address/order-address.component';
import { CourierInfoComponent } from './customer-order-tracking/components/courier-info/courier-info.component';
import { DeliveryPodComponent } from './customer-order-tracking/components/delivery-pod/delivery-pod.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ContactMerchantComponent } from './customer-order-tracking/components/contact-merchant/contact-merchant.component';
import { PhoneIconComponent } from './phone-icon/phone-icon.component';
import { EmailIconComponent } from './email-icon/email-icon.component';
import { GoogleReviewComponent } from './customer-order-tracking/components/google-review/google-review.component';
import { FacebookIconComponent } from './social-icons/facebook-icon/facebook-icon.component';
import { InstagramIconComponent } from './social-icons/instagram-icon/instagram-icon.component';
import { YoutubeIconComponent } from './social-icons/youtube-icon/youtube-icon.component';
import { TiktokIconComponent } from './social-icons/tiktok-icon/tiktok-icon.component';
import { ClickEventDirective } from './directives/click-event.directive';
import { CarouselModule } from 'primeng/carousel';
import { GalleriaModule } from 'primeng/galleria';
import { CollectionInstructionsComponent } from './customer-order-tracking/components/collection-instructions/collection-instructions.component';
import { CloseIconComponent } from './icons/close-icon/close-icon.component';
import { PackIconComponent } from './customer-order-tracking/components/collection-instructions/components/icons/pack-icon/pack-icon.component';
import { PrintIconComponent } from './customer-order-tracking/components/collection-instructions/components/icons/print-icon/print-icon.component';
import { GreetIconComponent } from './customer-order-tracking/components/collection-instructions/components/icons/greet-icon/greet-icon.component';
import { InstructionsStepComponent } from './customer-order-tracking/components/collection-instructions/components/instructions-step/instructions-step.component';
import { TranslocoModule } from '@ngneat/transloco';
import { InstructionsDialogComponent } from './customer-order-tracking/components/collection-instructions/components/instructions-dialog/instructions-dialog.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DownloadIconComponent } from './customer-order-tracking/components/collection-instructions/components/icons/download-icon/download-icon.component';
import { PromotionBannerComponent } from './customer-order-tracking/components/promotion-banner/promotion-banner.component';
import { ImageIconComponent } from './icons/image-icon/image-icon.component';
import { SafeLinkPipe } from './pipes/safe-link.pipe';
import { InstagramEmbeddedLinkPipe } from './pipes/instagram-link.pipe';
import { PromotionInstagramLinkComponent } from './customer-order-tracking/components/promotion-instagram-link/promotion-instagram-link.component';
import { InstagramPreviewIconComponent } from './icons/instagram-preview-icon/instagram-preview-icon.component';
import { GiftColoredIconComponent } from './customer-order-tracking/components/gift-colored-icon/gift-colored-icon.component';
import { OrderTrackingTitleComponent } from './customer-order-tracking/components/order-tracking-title/order-tracking-title.component';
import { TextareaAutoExpandDirective } from './directives/textarea-auto-expand.directive';
import { ExtendedDisplayDateFormatterPipe } from './pipes/extended-display-date-formatter.pipe';
import { HoursAmPmPipe } from './pipes/hours-am-pm.pipe';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MapComponent } from './map/map/map.component';
import { OrderStatusTrackingComponent } from './customer-order-tracking/components/order-status-tracking/order-status-tracking.component';
import { BackIconComponent } from './icons/back-icon/back-icon.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MakeChangesComponent } from './make-changes/make-changes.component';
import { PromotionProductsComponent } from './customer-order-tracking/components/promotion-products/promotion-products.component';
import { FabPromotionProductsComponent } from './customer-order-tracking/components/fab-promotion-products/fab-promotion-products.component';
import { ContainedDownArrowIconComponent } from './icons/contained-down-arrow-icon/contained-down-arrow-icon.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { AnimatedSvgComponent } from './customer-order-tracking/components/animated-svg/animated-svg.component';
import { EditOrderInitialMenuComponent } from './customer-order-tracking/components/edit-order-initial-menu/edit-order-initial-menu.component';
import { EditOrderContactUsButtonComponent } from './customer-order-tracking/components/edit-order-contact-us-button/edit-order-contact-us-button.component';
import { ChangeAddressFormComponent } from './customer-order-tracking/components/change-address-form/change-address-form.component';
import { EditOrderChangeDateTimeComponent } from './customer-order-tracking/components/edit-order-change-date-time/edit-order-change-date-time.component';
import { RecipientDetailsFormComponent } from './customer-order-tracking/components/recipient-details-form/recipient-details-form.component';
import { DeliveryInstructionsMenuComponent } from './customer-order-tracking/components/delivery-instructions-menu/delivery-instructions-menu.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IntlPhoneNumberComponent } from './intl-phone-number/intl-phone-number.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChangeAddressSearchInputComponent } from './customer-order-tracking/components/change-address-search-input/change-address-search-input.component';
import { ContactUsMenuComponent } from './customer-order-tracking/components/contact-us-menu/contact-us-menu.component';
import { EditOrderMenuComponent } from './customer-order-tracking/components/edit-order-menu/edit-order-menu.component';
import { MatStepperModule } from '@angular/material/stepper';
import { EditOrderInstructionsFormComponent } from './customer-order-tracking/components/edit-order-instructions-form/edit-order-instructions-form.component';
import { EditOrderFinalMessageComponent } from './customer-order-tracking/components/edit-order-final-message/edit-order-final-message.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ExternalLinkIconComponent } from './icons/external-link-icon/external-link-icon.component';
import { DaysAgoDisplayDateFormatterPipe } from './pipes/days-ago-display-date-formatter.pipe';
import { UKTimePipe } from './pipes/uk-date-formatter.pipe';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { AddisonLeeBannerComponent } from './customer-order-tracking/components/addison-lee-banner/addison-lee-banner.component';
import { ChatIconComponent } from './chat-icon/chat-icon.component';
import { MatTooltip } from '@angular/material/tooltip';
import { FailedDeliveryRebookFlowComponent } from './failed-delivery-rebook-flow/failed-delivery-rebook-flow.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MatExpansionModule,
    CarouselModule,
    GalleriaModule,
    NgOptimizedImage,
    TranslocoModule,
    MatDialogModule,
    OverlayPanelModule,
    MapComponent,
    CdkConnectedOverlay,
    MatBottomSheetModule,
    AnimatedSvgComponent,
    ReactiveFormsModule,
    IntlPhoneNumberComponent,
    MatDatepickerModule,
    MatStepperModule,
    MatTooltip,
    MatOptionModule,
    MatAutocompleteModule,
    MatTabsModule,
    AddisonLeeBannerComponent,
    FailedDeliveryRebookFlowComponent,
    CdkOverlayOrigin,
  ],
  declarations: [
    CustomerOrderTrackingComponent,
    EvermileLogoComponent,
    OrderStatusComponent,
    DisplayDateFormatterPipe,
    ExtendedDisplayDateFormatterPipe,
    DaysAgoDisplayDateFormatterPipe,
    HoursAmPmPipe,
    UKTimePipe,
    SafeLinkPipe,
    InstagramEmbeddedLinkPipe,
    OrderAddressComponent,
    CourierInfoComponent,
    DeliveryPodComponent,
    ContactMerchantComponent,
    MakeChangesComponent,
    PhoneIconComponent,
    ChatIconComponent,
    EmailIconComponent,
    GoogleReviewComponent,
    FacebookIconComponent,
    InstagramIconComponent,
    YoutubeIconComponent,
    TiktokIconComponent,
    ClickEventDirective,
    CollectionInstructionsComponent,
    CloseIconComponent,
    BackIconComponent,
    ContainedDownArrowIconComponent,
    PackIconComponent,
    PrintIconComponent,
    GreetIconComponent,
    DownloadIconComponent,
    InstructionsStepComponent,
    InstructionsDialogComponent,
    PromotionBannerComponent,
    ImageIconComponent,
    PromotionInstagramLinkComponent,
    InstagramPreviewIconComponent,
    GiftColoredIconComponent,
    OrderTrackingTitleComponent,
    TextareaAutoExpandDirective,
    OrderStatusTrackingComponent,
    PromotionProductsComponent,
    FabPromotionProductsComponent,
    EditOrderInitialMenuComponent,
    EditOrderContactUsButtonComponent,
    ChangeAddressFormComponent,
    EditOrderChangeDateTimeComponent,
    RecipientDetailsFormComponent,
    DeliveryInstructionsMenuComponent,
    ContactUsMenuComponent,
    EditOrderMenuComponent,
    ChangeAddressSearchInputComponent,
    EditOrderInstructionsFormComponent,
    EditOrderFinalMessageComponent,
    ExternalLinkIconComponent,
  ],
  providers: [
    DisplayDateFormatterPipe,
    ExtendedDisplayDateFormatterPipe,
    DaysAgoDisplayDateFormatterPipe,
    DatePipe,
    HoursAmPmPipe,
    UKTimePipe,
    SafeLinkPipe,
    InstagramEmbeddedLinkPipe,
    MatDialog,
  ],
  exports: [
    CustomerOrderTrackingComponent,
    EvermileLogoComponent,
    DisplayDateFormatterPipe,
    ExtendedDisplayDateFormatterPipe,
    DaysAgoDisplayDateFormatterPipe,
    HoursAmPmPipe,
    UKTimePipe,
    SafeLinkPipe,
    InstagramEmbeddedLinkPipe,
    PhoneIconComponent,
    ChatIconComponent,
    EmailIconComponent,
    BackIconComponent,
    ContainedDownArrowIconComponent,
    FacebookIconComponent,
    InstagramIconComponent,
    YoutubeIconComponent,
    TiktokIconComponent,
    ClickEventDirective,
    DeliveryPodComponent,
    PromotionBannerComponent,
    TextareaAutoExpandDirective,
    CloseIconComponent,
    EditOrderContactUsButtonComponent,
    ExternalLinkIconComponent,
  ],
})
export class CommonUiModule {}
